export default {
  lang: 'ru',
  dir: 'ltr',
  common: {
    ok: 'Сохранить',
    cancel: 'Отменить',
    key_backspace: 'Backspace',
    key_del: 'Delete',
    key_down: 'Вниз',
    key_up: 'Вверх',
    more_opts: 'Доп. Настройки',
    url: 'URL',
    width: 'Width',
    height: 'Height'
  },
  misc: {
    powered_by: 'Powered by'
  },
  ui: {
    toggle_stroke_tools: 'Показать/скрыть инструменты обводки',
    palette_info: 'Нажмите для изменения цвета заливки, Shift-Click изменить цвета обводки',
    zoom_level: 'Изменить масштаб',
    panel_action: 'Click to open side panel',
    quality: 'Качество:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: 'Идентификатор элемента',
    fill_color: 'Изменить цвет заливки',
    stroke_color: 'Изменить цвет обводки',
    stroke_style: 'Изменить стиль обводки',
    stroke_width: 'Изменить толщину обводки',
    pos_x: 'Изменить горизонтальный координат',
    pos_y: 'Изменить вертикальный координат',
    linecap_butt: 'Linecap: Butt',
    linecap_round: 'Linecap: Round',
    linecap_square: 'Linecap: Square',
    linejoin_bevel: 'Linejoin: Bevel',
    linejoin_miter: 'Linejoin: Miter',
    linejoin_round: 'Linejoin: Round',
    angle: 'Изменить угол поворота',
    blur: 'Изменяет значение размытия',
    opacity: 'Изменить непрозрачность элемента',
    circle_cx: 'Изменить горизонтальный координат (CX) окружности',
    circle_cy: 'Изменить вертикальный координат (CY) окружности',
    circle_r: 'Изменить радиус окружности',
    ellipse_cx: 'Изменить горизонтальный координат (CX) эллипса',
    ellipse_cy: 'Изменить вертикальный координат (CY) эллипса',
    ellipse_rx: 'Изменить горизонтальный радиус эллипса',
    ellipse_ry: 'Изменить вертикальный радиус эллипса',
    line_x1: 'Изменить горизонтальный координат X начальной точки линии',
    line_x2: 'Изменить горизонтальный координат X конечной точки линии',
    line_y1: 'Изменить вертикальный координат Y начальной точки линии',
    line_y2: 'Изменить вертикальный координат Y конечной точки линии',
    rect_height: 'Изменениe высоту прямоугольника',
    rect_width: 'Измененить ширину прямоугольника',
    corner_radius: 'Радиус закругленности угла',
    image_width: 'Изменить ширину изображения',
    image_height: 'Изменить высоту изображения',
    image_url: 'Изменить URL',
    node_x: 'Изменить горизонтальную координату узла',
    node_y: 'Изменить вертикальную координату узла',
    seg_type: 'Изменить вид',
    straight_segments: 'Отрезок',
    curve_segments: 'Сплайн',
    text_contents: 'Изменить содержание текста',
    font_family_label: 'Font:',
    font_family: 'Изменить семейство шрифтов',
    font_size: 'Изменить размер шрифта',
    bold: 'Жирный',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: 'Курсив',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Главное меню',
    bkgnd_color_opac: 'Изменить цвет фона или прозрачность',
    connector_no_arrow: 'Нет стрелки',
    fitToContent: 'Под размер содержимого',
    fit_to_all: 'Под размер всех слоев',
    fit_to_canvas: 'Под размер холста',
    fit_to_layer_content: 'Под размер содержания слоя',
    fit_to_sel: 'Под размер выделенного',
    align_relative_to: 'Выровнять по отношению к ...',
    relativeTo: 'По отношению к ',
    page: 'страница',
    largest_object: 'Наибольший объект',
    selected_objects: 'Выделенные объекты',
    smallest_object: 'Самый маленький объект',
    new_doc: 'Создать изображение',
    open_doc: 'Открыть изображение',
    export_img: 'Экспорт',
    save_doc: 'Сохранить изображение',
    import_doc: 'Импорт изображения',
    align_to_page: 'Align Element to Page',
    align_bottom: 'Выровнять по нижнему краю',
    align_center: 'Центрировать по вертикальной оси',
    align_left: 'По левому краю',
    align_middle: 'Центрировать по горизонтальной оси',
    align_right: 'По правому краю',
    align_top: 'Выровнять по верхнему краю',
    mode_select: 'Выделить',
    mode_fhpath: 'Карандаш',
    mode_line: 'Линия',
    mode_rect: 'Прямоугольник',
    mode_square: 'Квадрат',
    mode_fhrect: 'Прямоугольник от руки',
    mode_ellipse: 'Эллипс',
    mode_circle: 'Окружность',
    mode_fhellipse: 'Эллипс от руки',
    mode_path: 'Контуры',
    mode_text: 'Текст',
    mode_image: 'Изображение',
    mode_zoom: 'Лупа',
    no_embed: 'NOTE: This image cannot be embedded. It will depend on this path to be displayed',
    undo: 'Отменить',
    redo: 'Вернуть',
    tool_source: 'Редактировать исходный код',
    wireframe_mode: 'Каркас',
    clone: 'Клонировать элемент(ы)',
    del: 'Удалить элемент(ы)',
    group_elements: 'Создать группу элементов',
    make_link: 'Сделать ссылкой',
    set_link_url: 'Ссылка(оставьте пустым для удаления)',
    to_path: 'В контур',
    reorient_path: 'Изменить ориентацию контура',
    ungroup: 'Разгруппировать элементы',
    docprops: 'Свойства документа',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: 'Опустить',
    move_top: 'Поднять',
    node_clone: 'Создать копию узла',
    node_delete: 'Удалить узел',
    node_link: 'Связать узлы',
    add_subpath: 'Добавить линию',
    openclose_path: 'Разомкнуть/Замкнуть линию',
    source_save: 'Сохранить',
    cut: 'Вырезать',
    copy: 'Копировать',
    paste: 'Вставить',
    paste_in_place: 'Вставить сюда',
    Delete: 'Удалить',
    group: 'Группировка',
    move_front: 'На передний план',
    move_up: 'Передвинуть вперед',
    move_down: 'Передвинуть назад',
    move_back: 'На задний план',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: 'Слой',
    layers: 'Слои',
    del: 'Удалить слой',
    move_down: 'Опустить слой',
    new: 'Создать слой',
    rename: 'Переименовать Слой',
    move_up: 'Поднять слой',
    dupe: 'Копировать слой',
    merge_down: 'Объединить с нижним',
    merge_all: 'Объединить все',
    move_elems_to: 'Переместить выделенные элементы:',
    move_selected: 'Переместить выделенные элементы на другой слой'
  },
  config: {
    image_props: 'Свойства изображения',
    doc_title: 'Название',
    doc_dims: 'Размеры холста',
    included_images: 'Встроенные изображения',
    image_opt_embed: 'Локальные файлы',
    image_opt_ref: 'По ссылкам',
    editor_prefs: 'Параметры',
    language: 'Язык',
    background: 'Фон',
    editor_img_url: 'Изображение URL',
    editor_bg_note: '(Фон не сохранится вместе с изображением.)',
    select_predefined: 'Выбирать предопределенный размер',
    units_and_rulers: 'Единицы & Линейки',
    show_rulers: 'Показывать линейки',
    base_unit: 'Единицы:',
    grid: 'Сетка',
    snapping_onoff: 'Привязка вкл/выкл',
    snapping_stepsize: 'Шаг привязки:',
    grid_color: 'Цвет сетки',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'Некорректное значение аргумента',
    noContentToFitTo: 'Нет содержания, по которому выровнять.',
    dupeLayerName: 'Слой с этим именем уже существует.',
    enterUniqueLayerName: 'Пожалуйста, введите имя для слоя.',
    enterNewLayerName: 'Пожалуйста, введите новое имя.',
    layerHasThatName: 'Слой уже называется этим именем.',
    QmoveElemsToLayer: "Переместить выделенные элементы на слой '%s'?",
    QwantToClear: 'Вы хотите очистить?\nИстория действий будет забыта!',
    QwantToOpen: 'Открыть новый файл?\nИстория действий будет забыта!',
    QerrorsRevertToSource: 'Была проблема при парсинге вашего SVG исходного кода.\nЗаменить его предыдущим SVG кодом?',
    QignoreSourceChanges: 'Забыть без сохранения?',
    featNotSupported: 'Возможность не реализована',
    enterNewImgURL: 'Введите новый URL изображения',
    defsFailOnSave: 'NOTE: Due to a bug in your browser, this image may appear wrong (missing gradients or elements). It will however appear correct once actually saved.',
    loadingImage: 'Загрузка изоражения, придется подождать...',
    saveFromBrowser: "Выберите 'Сохранить как...' в вашем браузере (возможно через меню файл или в контекстном меню) чтобы сохранить как файл %s.",
    noteTheseIssues: 'Also note the following issues: ',
    unsavedChanges: 'Есть несохраненные изменения.',
    enterNewLinkURL: 'Введите новую ссылку URL',
    errorLoadingSVG: 'Ошибка: Не удалось загрузить SVG данные',
    URLLoadFail: 'Не удалось загрузить по ссылке URL',
    retrieving: 'Получение \'%s\' ...',
    popupWindowBlocked: 'Всплывающее окно могло заблокироваться браузером',
    exportNoBlur: 'Размытые элементы отображены как неразмытые',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Текст может показываться не так как должен',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
